// extracted by mini-css-extract-plugin
export default {"container":"counter_container__3omtd","value":"counter_value__L0MTT","divider":"counter_divider__Wk2q6","target":"counter_target__lfoS0","label":"counter_label__gLVlw"};